import { render, staticRenderFns } from "./TagCard.vue?vue&type=template&id=aaba93e2"
import script from "./TagCard.vue?vue&type=script&lang=js"
export * from "./TagCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports